import "./all-blocks";
import "./theme.scss";
import registerHighlight from "./shared/highlight";
import registerColors from "./shared/color";
import { isEditing } from "./shared/utils";

if (isEditing()) {
  registerColors();
  registerHighlight();
}
